import { Component, OnInit, inject } from '@angular/core';
import {MsAuthService} from './service';

@Component({
    selector: 'app-msal-auth',
    template: '',
    standalone: false
})
export class MsAuthComponent implements OnInit {
    private msAuthService = inject(MsAuthService);


    async ngOnInit(): Promise<void> {
        await this.msAuthService.isReady();

        if (this.msAuthService.isAuthenticated()) {
            await this.msAuthService.redirectAfterAuthentication();
        } else {
            await this.msAuthService.redirectAfterFailedAuthentication();
        }
    }

}
